import BasePopup from "../../../../src/scripts/classes/BasePopup";

var PopupItem = function(options) {
	// Call parent constructor
	BasePopup.call(this, $.extend(true, {
		baseClass: 'el-PopupItem',
		dotSelector: '.map-marker_icon-wrapper',
		popupSelector: '.map-marker_wrapper',
		pointerSelector: '.map-marker_pointer',
		componentName: 'PopupItem'
	}, options));
};

// Inherit from BasePopup
PopupItem.prototype = Object.create(BasePopup.prototype);
PopupItem.prototype.constructor = PopupItem;

export default PopupItem;

